import postAPI from './postAPI.js'

export default async function postDuplicateTaskFlow(id, name) {
    const data = await postAPI('admin/taskflows/duplicate', { id, name });
    return data;
}
